import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { SystemInputsTypes } from "@graylog/server-api";
import { defaultOnError } from "util/conditional/onError";
export const fetchInputType = async (type) => await SystemInputsTypes.info(type);
const useInputType = (type, { enabled } = { enabled: true }) => {
  const { data, refetch, isLoading } = useQuery({
    queryKey: ["inputType", type],
    queryFn: () => defaultOnError(
      fetchInputType(type),
      "Loading input type failed with status",
      "Could not load input type"
    ),
    placeholderData: keepPreviousData,
    enabled
  });
  return { data: data || void 0, refetch, isLoading };
};
export default useInputType;
